import React from "react";
import { formatCurrency, money } from "../../utils/helpers";

const productLabel = (item) => {
    return <span className="row pl-0 pr-5 align-items-center w-100">
        <span className="col-2 pr-1" style={{ minWidth: "80px", wordBreak: "break-all", fontSize: '12px' }}>
            {item.referencia}
        </span>

        <span className="col px-1" style={{fontSize: '12px'}}>{item.nombre}</span>
        
        <span
            className="col-2 px-1"
            style={{
                fontWeight: "bold",
                color: "#008aab",
                fontSize: '12px',
            }}
        >
            {isNaN(parseFloat(item.cantidad))
                ? "∞"
                : parseFloat(item.cantidad) + " " + item.unidad}
        </span>

        <span
            className="col-2 pr-0"
            style={{
                fontWeight: "bold",
                color: "#008aab",
                fontSize: '12px',
            }}
        >
            {formatCurrency(money(item.costo) || 0)}
        </span>
    </span>;
}

export default productLabel;